export const SOURCE_FALLBACKS: Record<string, string> = {
    PBS: '/assets/source-fallbacks/pbs.png',
    NPR: '/assets/source-fallbacks/npr.png',
    Axios: '/assets/source-fallbacks/axios.png',
    'The Hill': '/assets/source-fallbacks/the-hill.png',
    ABC: '/assets/source-fallbacks/abc.png',
    CBS: '/assets/source-fallbacks/cbs.png',
    Ballotpedia: '/assets/source-fallbacks/ballotpedia.png',
    'BBC News': '/assets/source-fallbacks/bbc-news.png',
    'Federal Register - Executive Orders': '/assets/source-fallbacks/federal-register-executive-orders.svg',
    'GovInfo - Congressional Bills': '/assets/source-fallbacks/govinfo-congressional-bills.svg',
    'New York Times': '/assets/source-fallbacks/new-york-times.png',
    CNN: '/assets/source-fallbacks/cnn.png',
    NBC: '/assets/source-fallbacks/nbc.png',
    Guardian: '/assets/source-fallbacks/guardian.png',
    Politico: '/assets/source-fallbacks/politico.png',
    Vox: '/assets/source-fallbacks/vox.png',
    'Fox News': '/assets/source-fallbacks/fox-news.png',
    Breitbart: '/assets/source-fallbacks/breitbart.png',
    'National Review': '/assets/source-fallbacks/national-review.png',
    'Washington Times': '/assets/source-fallbacks/washington-times.png',
    RealClearPolitics: '/assets/source-fallbacks/realclearpolitics.png',
    Reason: '/assets/source-fallbacks/reason.png',
    AlJazeera: '/assets/source-fallbacks/aljazeera.png',
  };
  
  export const GENERIC_FALLBACK_IMAGE = '/assets/images/fallback-news.png';
  
  function normalizeSourceName(source?: string | null): string {
    return (source || '')
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/news/g, '')
      .replace(/\.com/g, '')
      .replace(/\.org/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }
  
  export function getSourceFallback(source?: string | null): string | null {
    if (!source) {
      return null;
    }
  
    const exactMatch = SOURCE_FALLBACKS[source];
    if (exactMatch) {
      return exactMatch;
    }
  
    const normalizedSource = normalizeSourceName(source);
  
    const matchedEntry = Object.entries(SOURCE_FALLBACKS).find(([key]) => {
      const normalizedKey = normalizeSourceName(key);
  
      return (
        normalizedSource === normalizedKey ||
        normalizedSource.includes(normalizedKey) ||
        normalizedKey.includes(normalizedSource)
      );
    });
  
    if (matchedEntry) {
      const [matchedFallback] = matchedEntry;
        return matchedFallback;
    }
    
    return null;
  }
  
  export function getFallbackImage(source?: string | null): string {
    const sourceFallback = getSourceFallback(source);
  
    if (sourceFallback) {
      return sourceFallback;
    }
      return GENERIC_FALLBACK_IMAGE;
  }